<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo cliente</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a href="#info" role="tab" data-toggle="tab" class="nav-link active"> Dados CNPJ </a>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Sódio-Administrador </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Dados fiscais </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Serviços </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Acessos </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Status </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Arquivos </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Quadro Societário (QSA) </button>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="save">
                                    <fieldset>
                                        <legend>Dados gerais</legend>

                                        <div class="row mt-2">
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Matrícula</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: 1" v-model="client.mat">
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CNPJ*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xx.xxx.xxx/xxxx-xx" v-model="client.document"
                                                        v-mask="['##.###.###/####-##']">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            @click="searchCNPJ()"><i class="fa fa-search"></i>Buscar
                                                            CNPJ</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Razão Social*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="client.name">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Nome Fantasia</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="client.name_fantasy">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">NIRE</label>
                                                <input type="text" class="form-control" placeholder="Ex: #####"
                                                    v-model="client.nire">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CCMEI</label>
                                                <input type="text" class="form-control" v-model="client.ccmei"
                                                    placeholder="Ex: ######">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">E-mail</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: usuario@dominio.com" v-model="client.email">
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Telefone*</label>
                                                <input type="text" class="form-control" v-model="client.phone"
                                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                                    placeholder="(xx)x.xxxx-xxxx">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset class="mt-3">
                                        <legend>Endereço CNPJ</legend>
                                        <div class="row">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">CEP</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                                        v-model="client.zipcode" v-mask="['#####-###']">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                            CEP</button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-xl-7 col-md-7 col-sm-12">
                                                <label for="">Endereço*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                                    v-model="client.street">
                                            </div>
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Nº</label>
                                                <input type="text" class="form-control" placeholder="Ex: 100"
                                                    v-model="client.number_street">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <label for="">Complemento</label>
                                                <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                                    v-model="client.complement">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Bairro</label>
                                                <input type="text" class="form-control" placeholder="Ex: Centro"
                                                    v-model="client.district">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Cidade</label>
                                                <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                                    v-model="client.city">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">UF</label>
                                                <input type="text" class="form-control" placeholder="Ex: SP"
                                                    v-model="client.uf">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Observações</legend>
                                        <div class="row  mb-4">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="client.observation" placeholderSend="Sem observações"
                                                    ref="myChild">
                                                </editorText>
                                            </div>
                                        </div>
                                        <br>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Cadastrar</button>
                                            <router-link to="/client" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { getCNPJ, getCNPJAlternative, loadZipcode } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize, maskPhone } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';

export default {
    directives: { mask },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            tab_active: true,
            searchCnpj: true,
            client: {
                mat:'',
                document: '',
                name: '',
                name_fantasy:'',
                phone: '',
                email: '',
                nire: '',
                ccmei: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        onCancel() { },
        handleSelect(option) {
            this.client.gender = option.type;
        },
        searchZipcode() {
            this.isLoading = true;
            if (this.client.zipcode.length > 0) {
                let zipcode = this.client.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.client.street = response.street;
                    this.client.district = response.neighborhood;
                    this.client.city = response.city;
                    this.client.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        enableSearchCnpj() {
            let cnpjValid = false;
            if (this.client.document.length > 0) {
                let cnpj = this.client.document.replace(/\D/g, '');
                if (cnpj.length == 14) {
                    cnpjValid = true;
                }
            } 
          
            if(!cnpjValid){
                 this.$notify({
                    title: "Informação",
                    text: "Informe um CNPJ válido",
                    type: 'info'
                });
            }
            return cnpjValid;
        },
        searchCNPJ() {
            if (this.enableSearchCnpj()) {
                if (this.client.document.length > 0) {
                    this.isLoading = true;
                    let cnpj = this.client.document.replace(/\D/g, '');
                    getCNPJ(cnpj).then((response) => {
                        this.client.name = capitalize(response.razao_social);
                        this.client.phone = response.ddd_telefone_1 ? maskPhone(response.ddd_telefone_1) : '';
                        this.client.email = response.email ? response.email : '';
                        this.client.zipcode = response.cep ? capitalize(response.cep) : '';
                        this.client.street = response.logradouro ? capitalize(response.descricao_tipo_de_logradouro) + ' ' + capitalize(response.logradouro) : '';
                        this.client.complement = response.complemento ? capitalize(response.complemento) : '';
                        this.client.district = response.bairro ? capitalize(response.bairro) : '';
                        this.client.city = response.municipio ? capitalize(response.municipio) : '';
                        this.client.uf = response.uf ? response.uf : '';
                        this.isLoading = false;
                        if (this.client.email == '') {
                            getCNPJAlternative(cnpj).then((response) => {
                                this.client.email = response.email ? response.email.toLowerCase() : '';
                                this.client.number_street = response.numero ? response.numero : '';
                                this.client.name_fantasy = response.nome_fantasia ? capitalize(response.nome_fantasia) : '';
                            }).catch(() => {
                                this.isLoading = false;
                            });
                        }
                    }).catch(() => {
                        this.isLoading = false;
                    });
                }
            }

        },
        updateObservation(observation) {
            this.client.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client', this.client)
                .then((response) => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Cliente cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.client = {};
                    this.$router.push({
                        name: 'client_managing_partner',
                        params: { id: response.data.client.id }
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        }
    }
}
</script>

<style></style>